<script setup>
import FAQCell from '@/pages/faq/components/FAQCell.vue';
import FAQGroup from '@/components/common/FAQGroup.vue';

import { BLOOD_FAQ_ITEMS } from '@/constants/faq';

const items = [...BLOOD_FAQ_ITEMS];

const props = defineProps({});
</script>

<template>
  <FAQGroup title="Staking" bgVariant="pink">
    <template #graphic>
      <img src="@/images/mining_med.webp" :class="s.graphic" />
    </template>
    <FAQCell
      v-for="({ title, subcontent }, index) in items"
      :key="index"
      :title="title"
      :subcontent="subcontent"
    />
  </FAQGroup>
</template>

<style module="s" lang="scss">
.graphic {
  position: relative;
  left: -14px;
}
</style>
